<template>
    <div class="detail-box">
        <div class="title">
            <div class="icon" @click="$router.go(-1)">
                <a-icon type="left" style="color: #10141a" />
            </div>
            {{ $route.query.type == "userInfo" ? "个人信息" : "支付明细" }}
        </div>

        <!-- 内容 -->
        <div class="content">
            <!-- 个人信息 -->
            <div class="formBox" v-if="$route.query.type == 'userInfo'">
                <div class="radiusBox">
                    <!-- 基本信息 -->
                    <div class="formBox">
                        <div class="formRow">
                            <label>crm客户编号</label>
                            <span
                                class="text-copy"
                                v-if="userInfo.crmCustomerNo"
                                v-clipboard="{
                                    copyFieldValue: userInfo.crmCustomerNo,
                                }">
                                <a-icon type="copy" />
                                {{ userInfo.crmCustomerNo || "-" }}
                            </span>
                            <span v-else>-</span>
                        </div>
                        <div class="formRow">
                            <label>网校客户编号</label>
                            <span
                                class="text-copy"
                                v-if="userInfo.CustomerNo"
                                v-clipboard="{
                                    copyFieldValue: userInfo.CustomerNo,
                                }">
                                <a-icon type="copy" />
                                {{ userInfo.CustomerNo }}
                            </span>
                            <span v-else>-</span>
                        </div>
                        <div class="formRow">
                            <label>客户经理</label>
                            <div>
                                <a-tag style="color: #1890ff; background-color: #eaf5ff; border: none" v-if="userInfo.customerUserName">{{ userInfo.customerUserName }}</a-tag>
                                <span v-else>-</span>
                            </div>
                        </div>
                        <div class="formRow">
                            <label>班主任企微</label>
                            <div>
                                <template v-if="userInfo.addClassTeacherEnterpriseName.length > 0">
                                    <a-tag
                                        color="#18bc9c"
                                        v-for="(item, index) in userInfo.addClassTeacherEnterpriseName"
                                        :key="index"
                                        style="color: #ffffff; background-color: #18bc9c; white-space: normal"
                                        >{{ item }}</a-tag
                                    >
                                </template>

                                <span v-else>-</span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <DynamicForm
          class="userInfoForm"
          ref="userInfoForm"
          :fieldList="crmPersonalInfoFields"
          :filterType="0"
          :isEdit="false"
          :isEditFrozen="true"
          formType="crm"
        /> -->
                <DynamicForm class="userInfoForm" ref="userInfoForm" :form="form" :fieldList="crmPersonalInfoFields" :filterType="0" :isEdit="false" formType="crm" />
                <!-- v-if="crmPersonalInfoFields && crmPersonalInfoFields.length > 0" -->
                <!-- <div class="nullBox" v-else>
          <div class="txt">暂无学员个人信息</div>
        </div> -->
            </div>
            <!-- 订单 -->
            <div v-else>
                <!-- 有订单信息 -->
                <div class="orderDetailModal" style="width: 100%; height: calc(100% - 50px)" v-if="orderDetailList.length > 0">
                    <div v-for="item in orderDetailList" :key="item.id" class="itemBox" style="width: 96%; margin: 2%; /* height: 130px; */ border-radius: 10px; background-color: #ffffff">
                        <div style="width: 100%; line-height: 27px; padding: 12px 20px 0">
                            <span style="color: #666666">支付方式 :</span>
                            <span style="color: #111111; font-weight: 400"> {{ item.payWayName }}</span>
                        </div>
                        <div style="width: 100%; line-height: 27px; padding: 0 20px">
                            <span style="color: #666666">实付金额：</span>
                            <span style="color: #111111; font-weight: 400">{{ item.actualAmount | moneyFormat }}</span>
                        </div>
                        <!-- 分期期数 -->
                        <div style="width: 100%; line-height: 27px; padding: 0 20px">
                            <span style="color: #666666">分期期数：</span>
                            <span style="color: #111111; font-weight: 400">{{ item.divideNums }}</span>
                        </div>
                        <!-- 支付时间及状态 -->
                        <div class="item" style="display: flex; justify-content: space-between; margin-top: 4px; border-top: 1px solid #efeff0; line-height: 33px; width: 100%; padding: 0 20px">
                            <div style="width: 50%"><span style="color: #999999; font-size: 12px"></span>{{ item.payTime }}</div>
                            <div style="width: 50%; text-align: right">
                                <a-tag style="width: 57px; height: 23px; text-align: center" :color="`${payStatusColors[item.orderPayWayDetailPayStatus]}`">{{
                                    payStatusOptions[item.orderPayWayDetailPayStatus]
                                }}</a-tag>
                            </div>
                        </div>
                        <!-- 分期详情列表 -->
                        <div style="width: 100%; line-height: 27px">
                            <a-table
                                v-if="item.sdSchoolInstallments && item.sdSchoolInstallments.length > 0"
                                :columns="columns"
                                :data-source="item.sdSchoolInstallments"
                                :scroll="{ x: 1000, y: 150 }"
                                :pagination="false"
                                bordered
                                size="small">
                            </a-table>
                        </div>
                    </div>
                    <p style="color: #ccc; text-align: center; padding: 4px 0">已经到底了~</p>
                    <!-- 分期详情列表 -->
                </div>

                <!-- 无订单信息 -->
                <div class="orderDetailModal" style="height: 100px; overflow-y: auto; display: flex; align-items: center; justify-content: center" v-else>
                    <div style="display: flex; justify-content: center; align-items: center; color: gray">暂无支付明细</div>
                </div>
            </div>
        </div>
        <!-- 底部 -->
        <div class="botbtn">
            <div class="btn" @click="$router.go(-1)">返回</div>
        </div>
    </div>
</template>

<script>
// import  {LeftOutlined} from "@ant-design/icons-vue";
import store from "@/store";
import { moneyFormat } from "@/filters";
import { DynamicForm } from "@/components/DynamicComponents";
import { queryAdvertisingSpaceByChannel } from "@/api/detail";

export default {
    name: "detail",
    filters: { moneyFormat },
    components: {
        //   customForm,
        DynamicForm,
    },
    data() {
        return {
            // 用户个人信息
            userInfoFields: [],
            // 动态个人信息
            crmPersonalInfoFields: [],
            // 订单详情
            orderDetailList: [],
            // 静态个人信息
            userInfo: {},

            form: {},

            payStatusColors: {
                // 1: "#F59A24",
                1: "#DC021B",
                // 2: "#6DC83E",
                2: "#00B548",
                // 3: "#D9021C",
                3: "#DC021B",
                // 4: "#D9021C",
                4: "#999999",
            },
            payStatusOptions: {
                1: "待支付",
                2: "已支付",
                3: "缴费中",
                4: "已失效",
            },
            // 表格头-必写
            columns: [
                {
                    title: "期数",
                    dataIndex: "installmentDivideNo",
                    ellipsis: false,
                    align: "center",
                },
                {
                    title: "还款状态",
                    dataIndex: "installmentRepayStatus",
                    ellipsis: false,
                    align: "center",
                    customRender: (val) => {
                        let text = "-";
                        switch (val) {
                            case 1:
                                text = "待还款";
                                break;
                            case 2:
                                text = "已还款";
                                break;
                            case 3:
                                text = "逾期未还款";
                            case 4:
                                text = "已取消";
                                break;
                            case 5:
                                text = "已暂停";
                                break;
                        }
                        return text;
                    },
                },
                {
                    title: "还款来源",
                    dataIndex: "installmentRepaySource",
                    ellipsis: false,
                    align: "center",
                    customRender: (val) => {
                        let text = "-";
                        switch (val) {
                            case 1:
                                text = "客户还款";
                                break;
                            case 2:
                                text = "代偿";
                                break;
                            case 3:
                                text = "代偿后客户还款";
                                break;
                            case 4:
                                text = "回购";
                                break;
                        }
                        return text;
                    },
                },
                {
                    title: "应还金额",
                    dataIndex: "installmentShouldRepayAmount",
                    ellipsis: false,
                    align: "center",
                },
                {
                    title: "实际还款金额",
                    dataIndex: "installmentActualRepayAmount",
                    ellipsis: false,
                    align: "center",
                },
                {
                    title: "应还日期",
                    dataIndex: "installmentShouldRepayDate",
                    ellipsis: false,
                    align: "center",
                },
                {
                    title: "实际还款日期",
                    dataIndex: "installmentActualRepayDate",
                    ellipsis: false,
                    align: "center",
                },
                {
                    title: "逾期天数",
                    dataIndex: "installmentOverdueDays",
                    ellipsis: false,
                    align: "center",
                },
            ],
        };
    },
    // mixins: [checkMixin],
    computed: {},
    methods: {
        filtername(value) {
            if (value == null) return [];
            let arr = JSON.parse(value);
            let targetArr = [];
            arr.forEach((item, index) => {
                item.name.match(/\(([^)]+)\)/g).forEach((element) => {
                    console.log("拿到每一个值", element);

                    targetArr.push({
                        type: item.describe == "客户经理企微" ? 1 : 2,
                        value: element.slice(1, -1),
                    });
                });
            });

            let uniqueArray = [...new Set(targetArr.map(JSON.stringify))];
            targetArr = uniqueArray.map((item) => JSON.parse(item));
            // 排序 type 1在前，2在后
            targetArr.sort((a, b) => {
                return b.type - a.type;
            });
            return targetArr;
        },
    },
    async created() {
        let route = this.$route.query;
        console.log("拿到的路由参数", this.$route.query, route);

        if (route.type == "order") {
            // let { result } = await selectPayWayDetailsByOrderId({
            // orderId: route.order.orderId,
            // });
            this.orderDetailList = route.order;
            console.log("拿到订单信息", this.orderDetailList);
        } else {
            const customerDetails = JSON.parse(sessionStorage.getItem("customerDetails"));
            this.userInfoFields = customerDetails.crmPersonalCustomerModel;
            // 静态信息
            this.userInfo = customerDetails.basicCustomerInfo;
            console.log(399, this.userInfo);
            // 动态信息
            this.crmPersonalInfoFields = customerDetails.crmPersonalInfoFields.map((item) => {
                const newItem = { ...item };
                newItem["copyObject"] = {
                    corpId: store.getters.corpId || route.corpId,
                    wechatUserId: route.userId,
                    externalCustomerId: route.externalCustomerId,
                    copyFieldCode: item.fieldCode,
                    copyFieldValue: "",
                    customerId: this.userInfoFields.id,
                    moduleType: "20",
                    operateDataId: this.userInfoFields.id,
                    operateMenu: "企微侧边栏-个人信息详情",
                    dataCopyPlatform: 1, // 0: PC、1: APP
                };
                return newItem;
            });

            // 表单数据
            Object.assign(this.form, customerDetails.crmPersonalCustomerModel);
            console.log(332, this.form, customerDetails.crmPersonalCustomerModel);
            console.log("拿到用户信息", this.userInfoFields);
            console.log("拿到静态用户信息", this.userInfo);
            console.log("拿到动态用户信息", this.crmPersonalInfoFields);
        }
    },
    mounted() {},
    beforeDestroy() {},
};
</script>

<style lang="less" scope>
.formBox {
    .formRow {
        .text-copy {
            color: #1890ff !important;
            cursor: pointer !important;
        }
    }
}

.detail-box {
    width: 100%;
    height: 100vh;
    position: relative;

    .nullBox {
        color: #ccc;
        height: 150px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

        .txt {
            width: 190px;
            text-align: center;
        }
    }

    .title {
        width: 100%;
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 18px;
        // border-bottom: 1px solid #ccc;
        position: relative;
        font-weight: 500;

        .icon {
            position: absolute;
            left: 10px;
            font-size: 16px;
            width: 40px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            cursor: pointer;
            color: #ccc;
            font-weight: 700;
        }
    }

    .content {
        // width: 96%;
        // margin-left: 2%;
        width: 100%;
        height: calc(100% - 50px);
        background-color: #fafcff;
        // background-color: #ccc ;
        padding-bottom: 60px;
        overflow-y: auto;
    }

    .botbtn {
        width: 100%;
        height: 60px;
        position: absolute;
        bottom: 0;
        background-color: #fff;
        border-top: 1px solid #ccc;
        display: flex;
        align-items: center;
        justify-content: center;

        .btn {
            width: 60%;
            height: 40px;
            line-height: 40px;
            background-color: #0099ff;
            color: white;
            border-radius: 20px;
            margin: 0 auto;
            text-align: center;
            cursor: pointer;
            font-size: 14px;
        }
    }

    .ant-table td,
    .ant-table th {
        font-size: 12px; /* 你想要的字体大小 */
    }
}
</style>
